const el_filters = document.querySelectorAll('[name="topic"], [name="region"]'),
  el_tags = document.querySelectorAll('[data-tags]');

const applyFilter = () => {
  // Filter checked inputs
  const el_checked = [...el_filters].filter(el => el.checked && el.value);

  // Collect checked inputs values to array
  const filters = [...el_checked].map(el => el.value);

  // Get elements to filter
  const el_filtered = [...el_tags].filter(el => {
    const props = el.getAttribute('data-tags').trim().split(/\s+/);
    return filters.every(fi => props.includes(fi))
  });

  // Hide all
  el_tags.forEach(el => el.classList.add('is-hidden'));

  // Enable all
  el_filters.forEach(el => el.removeAttribute("disabled"));

  let difference = [];

  // Show filtered
  el_filtered.forEach(el => {
    el.classList.remove('is-hidden');

    difference = difference.concat(el.getAttribute('data-tags').trim().split(/\s+/));
  });

  var el_visibleFilters = difference.filter((item, pos) => difference.indexOf(item) === pos)

  var el_disabledFilters = [...el_filters].filter(el => {
    // "Alle"
    if (el.value === "") {
      return false;
    }
    // everything else:
    return !el_visibleFilters.includes(el.value);
  })

  el_disabledFilters.forEach(element => {
    element.setAttribute("disabled", "disabled");
  });
}

// Assign event listener
el_filters.forEach(el => el.addEventListener('change', applyFilter));

// Init
applyFilter();
